/* eslint-disable @next/next/no-before-interactive-script-outside-document */
import Script from 'next/script';

/**
 * This is async smartCode from VWO with some modifications (from docs):
 * - added 'window' to calls window._vwo_code.finish()
 * - hide_element is empty string, to disable vwo hiding page.
 * - _vis_opt_cookieDays is set to 56, by default this is 100
 */
export const initializeVWOAsynchronous = () => {
  return (
    <>
      {initializeElysiumVwoHandling()}
      <Script
        dangerouslySetInnerHTML={{
          __html: `window._vwo_code = window._vwo_code || (function () {
          var account_id = 142952,
          version = 1.5,
          settings_tolerance = 2000,
          library_tolerance = 2000,
          use_existing_jquery = false,
          is_spa = 1,
          _vis_opt_cookieDays = 56,
          hide_element = '',
          hide_element_style = 'opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important',
          /* DO NOT EDIT BELOW THIS LINE */
          f = false, d = document, vwoCodeEl = d.querySelector('#vwoCode'), code = { use_existing_jquery: function () { return use_existing_jquery }, library_tolerance: function () { return library_tolerance }, hide_element_style: function () { return '{' + hide_element_style + '}' }, finish: function () { if (!f) { f = true; var e = d.getElementById('_vis_opt_path_hides'); if (e) e.parentNode.removeChild(e) } }, finished: function () { return f }, load: function (e) { var t = d.createElement('script'); t.fetchPriority = 'high'; t.src = e; t.type = 'text/javascript'; t.onerror = function () { window._vwo_code.finish() }; d.getElementsByTagName('head')[0].appendChild(t) }, getVersion: function () { return version }, getMatchedCookies: function (e) { var t = []; if (document.cookie) { t = document.cookie.match(e) || [] } return t }, getCombinationCookie: function () { var e = code.getMatchedCookies(/(?:^|;)\\s?(_vis_opt_exp_\\d+_combi=[^;$]*)/gi); e = e.map(function (e) { try { var t = decodeURIComponent(e); if (!/_vis_opt_exp_\\d+_combi=(?:\\d+,?)+\\s*$/.test(t)) { return '' } return t } catch (e) { return '' } }); var i = []; e.forEach(function (e) { var t = e.match(/([\\d,]+)/g); t && i.push(t.join('-')) }); return i.join('|') }, init: function () { if (d.URL.indexOf('__vwo_disable__') > -1) return; window.settings_timer = setTimeout(function () { window._vwo_code.finish() }, settings_tolerance); var e = d.createElement('style'), t = hide_element ? hide_element + '{' + hide_element_style + '}' : '', i = d.getElementsByTagName('head')[0]; e.setAttribute('id', '_vis_opt_path_hides'); vwoCodeEl && e.setAttribute('nonce', vwoCodeEl.nonce); e.setAttribute('type', 'text/css'); if (e.styleSheet) e.styleSheet.cssText = t; else e.appendChild(d.createTextNode(t)); i.appendChild(e); var n = this.getCombinationCookie(); this.load('https://dev.visualwebsiteoptimizer.com/j.php?a=' + account_id + '&u=' + encodeURIComponent(d.URL) + '&f=' + +is_spa + '&vn=' + version + (n ? '&c=' + n : '')); return settings_timer } }; window._vwo_settings_timer = code.init(); return code;
        }());`,
        }}
        data-testid="vwoCode"
        id="vwoCode"
        type="text/javascript"
      />
    </>
  );
};

/**
 * Adds handlers to window object to handle VWO tests and enables useVwoTest hook
 */
const initializeElysiumVwoHandling = () => {
  return (
    <Script
      dangerouslySetInnerHTML={{
        __html: `
          ((w) => {
            if (w.vwo_testsInit) {
              return;
            }
            console.log('Initializing VWO handler');

            w.vwo_tests = [];
            w.vwo_createTest = (name, variation) => {
              if (w.vwo_getTest(name)) { 
                console.warn('VWO test '+name+' already exists');
                return;
              } else {
                console.log('VWO test '+name+' created, variation: '+variation);
              }
              const newTest = { name, variation };
              w.vwo_tests.push(newTest);

              const event = new CustomEvent('vwoTestCreated', { detail: newTest });
              dispatchEvent(event);
            };

            w.vwo_getTest = (testName) => {
              return w.vwo_tests.find((test) => test.name === testName);
            };

            w.vwo_addTestHandler = (testName, onSuccess, onFailure) => {
              const test = w.vwo_getTest(testName);
              if (test) {
                onSuccess(test);
              } else {
                const toleranceTimeout = setTimeout(
                  () => onFailure(), 
                  w._vwo_code.library_tolerance()
                );
                
                w.addEventListener('vwoTestCreated', (e) => {
                  if (e.detail.name === testName) {
                    onSuccess(e.detail);
                    clearTimeout(toleranceTimeout);
                  }
                }, {once: true});
              }
            };

            window.vwo_testsInit = true;
          })(window);        
          `,
      }}
      data-testid="vwoOnElysium"
      id="vwoOnElysium"
      type="text/javascript"
    />
  );
};
